/**
 * @exports
 * @class SinglePost
 */
import * as basicLightBox from 'basiclightbox';
import * as Flickity from 'flickity';

import { get, removeLastURLSegment } from '../../helpers/utilities';

export class SinglePost {
    private instance: basicLightBox.BasicLightBox;

    /**
     * Opens the single post in a basicLightBox
     * 
     * @param template The single post template.
     */
    constructor(template: HTMLElement | string) {
        const content = typeof template === 'string' ? template : template.innerHTML
        this.instance = basicLightBox.create(content, {
            onClose: ({}) => {
                if(history.pushState) {
                    history.pushState('', '', removeLastURLSegment());
                }
                return true;
            }
        });
        this.instance.show();
        this.initGallery();
        this.closeBtn();
    }


    /**
     * Initiate our gallery for the single post
     * 
     * @private
     * @returns void
     */
    private initGallery(): void {
        const gallery = get('.js-single-post__gallery', this.instance.element());
        if(gallery) {

            new Flickity(gallery, {
                pageDots: false,
                wrapAround: true,
                setGallerySize: false
            });
        }
    }


    /**
     * Closes the popup when clicking the close button
     */
    private closeBtn(): void {
        const closeBtn = get('.js-single-post__close', this.instance.element());
        if(closeBtn) {
            closeBtn.addEventListener('click', () => {
                this.instance.close();
            });
        }
    }
}
